import { render, staticRenderFns } from "./niqSet.vue?vue&type=template&id=23467716&scoped=true&"
import script from "./niqSet.vue?vue&type=script&lang=js&"
export * from "./niqSet.vue?vue&type=script&lang=js&"
import style0 from "./niqSet.vue?vue&type=style&index=0&id=23467716&prod&lang=scss&scoped=true&"
import style1 from "./niqSet.vue?vue&type=style&index=1&id=23467716&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23467716",
  null
  
)

export default component.exports